<table class="table table-borderless table-centered align-middle table-nowrap small">
  <thead class="text-muted table-light">
    <tr class="align-middle">
      <th scope="col" class="py-2">Application</th>
      <th scope="col" class="py-2 align-middle text-end">
        <span class="d-inline-block" style="line-height: 1.2;">Total Usage</span>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (data of applicationUsageSummary; track $index) {
      <tr class="align-middle">
        <td class="py-2">
          <span>{{ data.application }}</span>
        </td>
        <td class="text-end py-2">{{ data.totalUsageWithDataUnit }}</td>
      </tr>
    }
  </tbody>
</table>
